import { useSelector } from "react-redux";
import { Button } from "src/components";
import SmartForm from "src/container/smart-form.component";
import { RootState } from "src/context/store";
import { getOrderedProducts, getSimilarCompanyProducts } from "src/services/invoice-api";

interface InvoiceEntryFormProps {
    handleAddProduct: (data: any) => void;
    smartFormInstance: any;
    useOrderedProducts: string;
    schema: any;
    handleAutocompleteChange: (value: any) => void;
    selectedPriceIdentifier: any;
    setSelectedBatch: (batch: any) => void;
    fetchOrderedProductsByItemCode: (itemCode: string) => Promise<any>;
    fetchProductsDataForItemCode: (itemCode: string) => Promise<any>;
    batchList: any[];
    priceList: any[];
    gstAmbiguous: boolean;
    setGstAmbiguous: (gstAmbiguous: boolean) => void;
    setPrice: (price: number) => void;
    quantity: number;
    setQuantity: (quantity: number) => void;
    priceIdentifierList: any[];
    setSelectedPriceIdentifier: (selectedPriceIdentifier: any) => void;
    discountPercentage: number;
    discountAmount: number;
    handlePercentageChange: (e: any) => void;
    handleAmountChange: (e: any) => void;
}


const InvoiceEntryForm = (
    { handleAddProduct,
        smartFormInstance,
        useOrderedProducts,
        schema,
        handleAutocompleteChange,
        selectedPriceIdentifier,
        setSelectedBatch,
        fetchOrderedProductsByItemCode,
        fetchProductsDataForItemCode,
        batchList,
        priceList,
        gstAmbiguous,
        setGstAmbiguous,
        setPrice,
        quantity,
        setQuantity,
        setSelectedPriceIdentifier,
        discountPercentage,
        discountAmount,
        handlePercentageChange,
        handleAmountChange,
        priceIdentifierList }: InvoiceEntryFormProps) => {


    const { invoiceDetails } = useSelector((state: RootState) => state.invoice);

    const fetchOrderedProducts = async (query: string) => {
        if (useOrderedProducts === "unknown" || query.length == 1 || query.length == 2) {
            return;
        }
        try {
            return await getOrderedProducts({
                product_name: query,
                counter_code: invoiceDetails?.counter_code,
                item_code: "",
                page: 1,
                page_size: 10,
                company_stockist_code: invoiceDetails?.company_stockist_code,
                invoice_date: invoiceDetails?.invoice?.new_invoice_date,
                company_code: invoiceDetails?.company_code,
            });
        } catch (error) {
            console.log(error);
        }
    };

    const fetchProductsData = async (query: string) => {
        if (useOrderedProducts === "unknown") {
            return;
        }
        try {
            return await getSimilarCompanyProducts(invoiceDetails?.company_code, query, "", 1, 10);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div>
            <SmartForm onFormSubmit={handleAddProduct} schema={schema} isControlled={false} formInstance={smartFormInstance} defaultValues={{}}>
                <div className="grid grid-cols-4 gap-4">
                    {useOrderedProducts === "unknown" ? (
                        <SmartForm.Input
                            className="w-full py-0"
                            inputClassName="w-full py-1"
                            type="text"
                            placeholder=" "
                            fieldName="itemCode"
                            label="Item Code"
                            showRequiredMark={false}
                        />
                    ) : (
                        <SmartForm.Autocomplete
                            className="z-10 w-full"
                            suggestionList={[]}
                            placeholder=" "
                            fieldName="itemCode"
                            label="Item Code"
                            showRequiredMark={false}
                            customFieldName="itemCode"
                            uniqueKey="id"
                            displayKey="item_code"
                            allowCustomValue={useOrderedProducts === "unknown"}
                            onChange={(value) => {
                                // update other fields from this if it exists
                                const { setValue }: any = smartFormInstance;
                                setValue("itemCode", value?.item_code);
                                handleAutocompleteChange(value);
                            }}
                            // additionDisplayKey="companyProducts.item_code"
                            isControlled={false}
                            asyncListFunction={
                                useOrderedProducts === "ordered"
                                    ? fetchOrderedProductsByItemCode
                                    : useOrderedProducts === "company"
                                        ? fetchProductsDataForItemCode
                                        : ""
                            }
                        />
                    )}
                    {useOrderedProducts === "unknown" ? (
                        <SmartForm.Input
                            className="w-full py-0"
                            inputClassName="w-full py-1"
                            type="text"
                            placeholder=" "
                            fieldName="itemName"
                            label="Item Name"
                            showRequiredMark={false}
                        />
                    ) : (<SmartForm.Autocomplete
                        className="z-10 w-full"
                        suggestionList={[]}
                        placeholder=" "
                        fieldName="itemName"
                        customFieldName="itemName"
                        label="Item Name"
                        showRequiredMark={false}
                        uniqueKey="id"
                        displayKey={"product_name"}
                        additionDisplayKey={"item_code"}    // M10-10991 
                        additionalDisplayKeySearch={true}   // M10-10991 
                        allowCustomValue={useOrderedProducts === "unknown"}
                        onChange={(value) => {
                            // update other fields from this if it exists
                            const { setValue }: any = smartFormInstance;
                            setValue("itemName", value?.product_name);
                            handleAutocompleteChange(value);
                        }}
                        isControlled={false}
                        asyncListFunction={
                            useOrderedProducts === "ordered" ? fetchOrderedProducts : useOrderedProducts === "company" ? fetchProductsData : ""
                        }
                    />)}
                    {(<SmartForm.Autocomplete
                        className="z-10 w-full"
                        suggestionList={priceList}
                        placeholder=" "
                        fieldName="itemPrice"
                        label="MRP - PTR"
                        showRequiredMark={false}
                        uniqueKey="company_productprice_id"
                        displayKey="mrp"
                        additionDisplayKey={useOrderedProducts === "unknown" ? "" : "ptr"}
                        customFieldName="itemPrice"
                        allowCustomValue={priceList?.length ? false : true}
                        showAdditionalDisplayKeyWhenSelected={false}
                        onChange={(value) => {
                            // update other fields from this if it exists
                            // handleAutocompleteChange(value);
                            const { setValue }: any = smartFormInstance;
                            setValue("mrp", value?.mrp);
                            setValue("price", value?.ptr);
                            setValue("ptr", value?.ptr);
                            setPrice(value?.ptr);
                            setValue("gst", value?.company_productcode?.gst_pc);
                            setGstAmbiguous(value?.company_productcode?.gst_ambiguous);
                            // setValue("quantity", "");        //M10-9685
                            // setValue("schemeType", "");      //M10-9685
                            // setValue("batchNo", "");         //M10-9685
                            setValue("discountPercentage", "");
                            setValue("discountAmount", "");
                            // setValue("freeQty", "");         //M10-9685
                        }}
                        isControlled={false}
                    // fetchOnHover={true} REMOVED ON FOCUS
                    // asyncListFunction={}
                    />)}
                    <SmartForm.Input
                        className="w-full"
                        inputClassName="w-full"
                        type="text"
                        placeholder=" "
                        fieldName="ptr"
                        label="PTR"
                        disabled={useOrderedProducts !== "unknown"}
                        showRequiredMark={false}
                    />
                    <SmartForm.Input
                        className="w-full"
                        inputClassName="w-full"
                        type="number"
                        placeholder=" "
                        fieldName="price"
                        label="Price"
                        showRequiredMark={false}
                        changeHandler={(e: any) => {
                            setPrice(e);
                        }}
                    />
                    <SmartForm.Input
                        className="w-full"
                        inputClassName="w-full"
                        type="number"
                        placeholder=" "
                        fieldName="gst"
                        label="GST%"
                        showRequiredMark={false}
                        disabled={!gstAmbiguous && useOrderedProducts !== "unknown"}
                    />
                    <SmartForm.Autocomplete
                        className="w-full"
                        suggestionList={priceIdentifierList}
                        placeholder=" "
                        fieldName="schemeType"
                        label="Scheme Type"
                        showRequiredMark={false}
                        uniqueKey="key"
                        displayKey="description"
                        onChange={(val) => {
                            setSelectedPriceIdentifier(val);
                            const { setValue }: any = smartFormInstance;
                            if (val?.priceldentifier_id === 1 || val?.priceldentifier_id === 2) {
                                setValue("freeQty", "");
                            }
                            if (val?.priceldentifier_id === 3) {
                                setValue("discountPercentage", "");
                                setValue("discountAmount", "");
                            }
                        }}
                    />
                    <SmartForm.Input
                        className="w-full"
                        inputClassName="w-full"
                        type="number"
                        placeholder=" "
                        fieldName="quantity"
                        label="Quantity"
                        value={quantity}
                        showRequiredMark={false}
                        changeHandler={(e: any) => {
                            setQuantity(e);
                        }}
                    />
                    {selectedPriceIdentifier?.key == "SCHEME" && (
                        <SmartForm.Input
                            className="w-full"
                            inputClassName="w-full"
                            type="text"
                            label="Free Qty"
                            showRequiredMark={false}
                            placeholder=" "
                            fieldName="freeQty"
                        />
                    )}
                    {(selectedPriceIdentifier?.key == "DISCOUNT_PERCENT" || selectedPriceIdentifier?.key == "DISCOUNT_AMOUNT") && (
                        <>
                            {" "}
                            <SmartForm.Input
                                className="w-full"
                                inputClassName="w-full"
                                type="text"
                                label="Discount Percent"
                                showRequiredMark={false}
                                placeholder=" "
                                value={discountPercentage}
                                disabled={selectedPriceIdentifier?.key == "DISCOUNT_AMOUNT"}
                                fieldName="discountPercentage"
                                changeHandler={handlePercentageChange}
                            />
                            <SmartForm.Input
                                className="w-full"
                                inputClassName="w-full"
                                type="number"
                                label="Discount Amount"
                                showRequiredMark={false}
                                placeholder=" "
                                disabled={selectedPriceIdentifier?.key == "DISCOUNT_PERCENT"}
                                fieldName="discountAmount"
                                value={discountAmount}
                                changeHandler={handleAmountChange}
                            />{" "}
                        </>
                    )}
                    {
                        useOrderedProducts === "unknown" ? (
                            <SmartForm.Input
                                className="w-full py-0"
                                inputClassName="w-full py-1"
                                type="text"
                                placeholder=" "
                                fieldName="batchNo"
                                label="Batch No."
                                showRequiredMark={false}
                            />
                        ) :
                            (<SmartForm.Autocomplete
                                className="w-full"
                                label="Batch No."
                                showRequiredMark={false}
                                placeholder=" "
                                fieldName="batchNo"
                                suggestionList={batchList}
                                uniqueKey="batch_no"
                                displayKey="batch_no"
                                allowCustomValue={true}
                                onChange={(val) => {
                                    setSelectedBatch(val);
                                    const { setValue }: any = smartFormInstance;
                                    setValue("batchNo", val?.batch_no);
                                }}
                            // fetchOnHover={true} REMOVED ON FOCUS
                            />)
                    }
                    {/* {batchList.length === 0 && (
                      <SmartForm.Input
                        className="w-full"
                        inputClassName="w-full"
                        type="string"
                        label="Batch No."
                        showRequiredMark={false}
                        placeholder=" "
                        disabled={batchList?.length > 0}
                        fieldName="batchNo"
                        value={batchNo}
                        changeHandler={handleBatchNo}
                      />
                    )} */}
                </div>
                <div className="flex justify-end pb-5 mt-5 gap-x-2">
                    {/* <Button className="font-normal text-gray-700 bg-[#F1F1F1] h-9 border-2 border-gray-200" onClick={resetFormFields}>
                            Add another item
                          </Button> */}

                    <Button className="h-9 text-white font-normal bg-[#8051FF] shadow-sm" type="submit">
                        Add Product
                    </Button>
                </div>
            </SmartForm>
        </div>
    );
};

export default InvoiceEntryForm;